import React, {
    Fragment,
    useState,
    useEffect,
    useRef,
    useCallback,
  } from "react";
  import Header from "../components/Header";
  import Leftnav from "../components/Leftnav";
  import Appfooter from "../components/Appfooter";
  import PeopleCard from "../components/PeopleCard";
  import { useAPI } from "../context/ApiContext";
  import { useTranslation } from "react-i18next";
  import { makeStyles } from "@material-ui/core/styles";
  
  const useStyles = makeStyles((theme) => ({
    line: {
      display: "block",
      position: "relative",
      "&::after": {
        background: "linear-gradient(to right,#79ac78 0%,#79ac78 50%,#79ac78 100%)",
        content: '""',
        display: "block",
        height: "2px",
        width: 0,
        transform: "translateX(-50%)",
        transition: "2s cubic-bezier(0.22, 1, 0.36, 1)",
        position: "absolute",
        bottom: 0,
        left: "50%",
      },
      "&.is-animated::after": { width: "100%" },
    },
  }));
  
  const PAGE_SIZE = 20;
  
  const PeopleSearch = () => {
    const api = useAPI();
    const { t } = useTranslation();
    const classes = useStyles();
  
    const [inputValue, setInputValue] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [items, setItems] = useState([]);
    const [animate, setAnimate] = useState(false);
  
    const [count, setCount] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const loaderRef = useRef(null);
  
    // 初期アニメーション
    useEffect(() => setAnimate(true), []);
  
    // 送信（Enter）で検索実行
    const handleSubmit = (e) => {
      e.preventDefault();
      const q = inputValue.trim();
      setItems([]);
      setCount(0);
      setHasMore(true);
      setSearchTerm(q);
    };
  
    const load = useCallback(
      async (c) => {
        if (loading || !hasMore) return;
        setLoading(true);
        try {
          const res = await api.searchProfiles({ q: searchTerm || "", count: c || 0 });
          const list = Array.isArray(res?.res) ? res.res : [];
          const total = typeof res?.totalCount === "number" ? res.totalCount : undefined;
  
          setItems((prev) => (c === 0 ? list : [...prev, ...list]));
  
          if (total !== undefined) {
            const loaded = (c + 1) * PAGE_SIZE;
            setHasMore(list.length > 0 && loaded < total + PAGE_SIZE);
          } else {
            setHasMore(list.length > 0);
          }
        } catch {
          setHasMore(false);
        } finally {
          setLoading(false);
        }
      },
      [api, searchTerm, loading, hasMore]
    );
  
    // 初回・検索語変更時に1ページ目取得
    useEffect(() => {
      setItems([]);
      setCount(0);
      setHasMore(true);
      load(0);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm]);
  
    // 無限スクロール
    useEffect(() => {
      const io = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (entry.isIntersecting && !loading && hasMore) {
            const next = count + 1;
            setCount(next);
            load(next);
          }
        },
        { root: null, rootMargin: "0px", threshold: 1.0 }
      );
      if (loaderRef.current) io.observe(loaderRef.current);
      return () => io.disconnect();
    }, [count, hasMore, loading, load]);
  
    return (
      <Fragment>
        <Header />
        <Leftnav />
  
        <div className="main-content right-chat-active">
          <div className="middle-sidebar-bottom">
            <div className="middle-sidebar-left pe-0">
              <div className="row">
                <div className="col-xl-12">
                  {/* 見出し + 検索フォーム（UIはほぼ据え置き） */}
                  <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3">
                    <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900 d-flex align-items-center">
                      {t("Recommenduser4") || "ユーザーを探す"}
                      <form className="pt-0 pb-0 ms-auto" onSubmit={handleSubmit}>
                        <div className="search-form-2 ms-1">
                          <i className="ti-search font-xss" />
                          <input
                            type="text"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            className="form-control text-grey-500 mb-0 bg-greylight theme-dark-bg border-0"
                            placeholder={t("Recommenduser3") || "ユーザー名で検索"}
                          />
                        </div>
                      </form>
                    </h2>
                  </div>
  
                  {/* ガイドライン（アニメ線） */}
                  {/* <div
                    className={`${classes.line} ${animate ? "is-animated" : ""} font-xssss text-center text-current fw-600 mt-0 mb-2`}
                  >
                    {inputValue
                      ? t("Recommenduser1") || "検索結果"
                      : t("Recommenduser2") || "おすすめユーザー"}
                  </div> */}
  
                  {/* グリッド */}
                  <div className="row ps-3 pe-3">
                    {items.length > 0 ? (
                      items.map((u, idx) => (
                        <PeopleCard key={u.userId || u.id || idx} item={u} />
                      ))
                    ) : !loading ? (
                      <div className="font-xssss text-grey-600 text-center mt-3">No search results</div>
                    ) : null}
                  </div>
  
                  {/* センチネル */}
                  <div ref={loaderRef} style={{ height: 20, margin: "0 auto" }} />
  
                  {/* ローディング */}
                  {loading && (
                    <div className="card-body p-0 mb-3">
                      <div className="card w-100 shadow-xss rounded-xxl border-0 p-4 mb-3">
                        <div className="snippet mt-2 ms-auto me-auto" data-title=".dot-typing">
                          <div className="stage">
                            <div className="dot-typing" />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
  
                  <div className="p-4 mb-3" />
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <Appfooter />
      </Fragment>
    );
  };
  
  export default PeopleSearch;
  